<template>
  <div>
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      @branchChange="handleBranchChange"
      @update:searchQuery="searchQuery = $event"
    />

    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" md="12" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title">Invoices List</h4>
              </div>
            </div>

            <div class="iq-card-body overflow-auto">
              <FormGenerator
                :Fields="fields"
                :model="model"
                :options="options"
              />

              <!-- error and success message -->
              <Error_messages
                :error_message="messages.error"
                :success_message="messages.success"
              />
              <b-overlay :show="loading" rounded="sm" variant="Primary"></b-overlay>
              <b-table
                class="table b-table table-striped"
                :items="this.getLocalizedData"
                :fields="columns.map(col => col.prop)"
                striped
                ref="table"
              >
                <template
                  v-for="column in columns"
                  #[`cell(${column.prop})`]="data"
                >
                  <span v-if="!column.isAction">
                    {{ data.item[column.prop] || column.default }}
                  </span>

                  <span v-else>
                    <div class="d-flex justify-content-around"></div>
                  </span>
                </template>
              </b-table>

              <div
                class="mt-3 d-flex justify-content-center"
                v-if="!this.searchQuery"
              >
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="InvoicesList"
                />
              </div>
              <EmptySearchMessage v-if="EmptySearchMessage" />

              <div v-if="isEmptylist" class="iq-card-header">
                <div class="iq-card-body">
                  <div class="iq-card">
                    <h4 class=" text-center bg-info">
                      You don't have any items in your list
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import TableConfiguration from "./TableConfiguration";
import { Fields, options, models } from "./form_fields";
import moment from "moment";
import { core } from "@/config/pluginInit";
import { InvoiceStatusOptions, InvoiceTypeOptions } from "@/config/Invoices";
import Error_messages from "@/helpers/error_messages.vue";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";
import { getInvoicesFiltered } from "@/API/InvoicesAPIs";
export default {
  name: "InvoicesList",
  mixins: [TableConfiguration],
  components: {
    Error_messages,
    SearchFilters,
    EmptySearchMessage,
    FormGenerator
  },
  data() {
    return {
      loading: false,
      model: { ...models },
      options,
      fields: Fields,
      items: [],
      searchQuery: "",
      businessId: null,
      branchId: null,
      deletedItem: null,
      showAdd: true,
      editModel: null,
      messages: { error: "", success: "" },
      EmptySearchMessage: false,
      showSearchBox: false,
      isEmptylist: false
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    getLocalizedData() {
      return this.items.map(item => {
        const localizedData =
          item.reservation.data.reservable.locales.find(
            locale => locale.locale === 'en'
          ) || item.locales[0];
        return {
          ...item,
          reservation: localizedData.name || "",
          for_user: item.for_user.name || "",
          by_user: item.by_user.name || "",
          created_at: moment(item.created_at).format("DD-MM-YYYY hh:mm A")
        };
      });
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.userBusinesses.find(b => b.id === this.businessId)?.branches || [];
    }
  },

  async mounted() {
    core.index();
    this.InvoicesList();
    this.setInvoiceOptions();
    this.model.dateRange = [
      moment()
        .subtract(1, "months")
        .toDate(),
      moment().toDate()
    ];
    this.model.from = this.model.dateRange[0];
    this.model.to = this.model.dateRange[1];
  },
  methods: {
    setInvoiceOptions() {
      if (!this.fields || !Array.isArray(this.fields)) return;

      const typeField = this.fields.find(field => field.name === "type");
      const statusField = this.fields.find(field => field.name === "status");

      if (typeField) {
        typeField.options = InvoiceTypeOptions;
      }
      if (statusField) {
        statusField.options = InvoiceStatusOptions;
      }
    },
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    handleBranchChange(newValue) {
      if (newValue !== this.branchId) {
        this.branchId = newValue;
      }
    },
    async InvoicesList(page = 1) {
      if (!this.businessId || !this.branchId) return;
      this.loading = true;
      var data = { ...this.model };
      try {
        const perPage = this.searchQuery
          ? this.paginationMeta.total
          : this.paginationMeta.per_page;
        const response = await getInvoicesFiltered({
          businessId: this.businessId,
          branchId: this.branchId,
          "per-page": perPage,
          page,
          ...data
        });
        this.items = response.data;
        if (response.data.length) {
          this.isEmptylist = false;
          this.getLocalizedData.length == 0
            ? (this.EmptySearchMessage = true)
            : (this.EmptySearchMessage = false);
        } else {
          this.isEmptylist = true;
        }

        this.paginationMeta = response.meta;
      } catch (error) {
        console.error(error);
        this.items = [];
      }finally {
      this.loading = false;
    }
    },
    editMenu(model) {
      this.showAdd = false;
      const requiredLocales = ["en", "ar"];
      this.editModel = {
        ...model,
        locales: requiredLocales.map(
          locale =>
            model.locales.find(l => l.locale === locale) || {
              locale,
              name: "",
              description: "",
              id: ""
            }
        )
      };
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  },
  watch: {
    branchId(newBranchId, oldBranchId) {
      if (oldBranchId !== null && newBranchId !== oldBranchId) {
        this.InvoicesList();
      }
    },
    userBusinesses(newBusinesses) {
      if (newBusinesses.length > 0 && !this.businessId) {
        this.businessId = newBusinesses[0].id;
        this.InvoicesList();
      }
    },
    userBranches(newBranches) {
      if (newBranches.length > 0 && !this.branchId) {
        this.branchId = newBranches[0].id;
        this.InvoicesList();
      }
    },
    model: {
      deep: true,
      handler(val, oldVal) {
        this.page = 1;
        const newFrom = moment(val.dateRange[0])
          .startOf("day")
          .toDate();
        const newTo = moment(val.dateRange[1])
          .endOf("day")
          .toDate();

        if (
          this.model.from?.getTime() !== newFrom.getTime() ||
          this.model.to?.getTime() !== newTo.getTime()
        ) {
          this.model.from = newFrom;
          this.model.to = newTo;
        }
        this.InvoicesList();
      }
    }
  }
};
</script>

<style scoped></style>
